<template>

    <div class="galaxy::common-canvas-Editor tw-bg-white tw-flex tw-flex-col tw-h-full">

        <div class="tw-flex tw-flex-col tw-h-full tw-w-full">

            <ToolbarTop
                    :activeCanvasVersion="activeCanvasVersion"
                    :canvasVersion="canvasVersion"
                    :versionState="versionState"
                    :activeMode="activeMode"
                    :title="title"
                    :instruction="instruction"
                    :currentLanguageToShow="isMultiLanguage ? currentLanguage : null"/>

            <div class="tw-h-full tw-flex tw-overflow-hidden">

                <canvas-component
                        ref="canvasComponent"
                        :canvasVersion="canvasVersion"
                        :activeMode="activeMode"
                        :activeViewport="activeViewport"
                        :stateSaving="stateSaving"
                        :galleryDraggingBlockId="galleryDraggingBlockId"
                        @loaded="iframeLoaded = true"/>

                <gallery
                        v-if="activeMode == 'overview'"
                        :canvasBlocksGalleryData="canvasBlocksGalleryData"
                        :canvasVersion="canvasVersion"
                        @onDraggingBlockId="galleryDraggingBlockId = $event"
                        @addBlock="$refs['canvasComponent'].pageAddBlock($event)"/>

            </div>

            <div class="text-right card tw-my-0 tw-py-3 toolbarBottom" :class="{ loading: !iframeLoaded || stateSaving }">
                <div class="card-body tw-py-0 tw-flex">

                    <ModeAndViewportToolbar
                            :activeMode.sync="activeMode"
                            :activeViewport.sync="activeViewport" />

                    <VersionActions
                            :canvas-version="canvasVersion"
                            :version-state="versionState"
                            :useVersioning="useVersioning"
                            :currentLanguage="currentLanguage"
                            @update.canvasVersion="setNewLanguageCanvasVersion($event)"
                            @onNewCanvasVersions="setNewCanvasVersions($event)"
                            @canvasVersionBackToLive="canvasVersionBackToLive"/>

                </div>
            </div>

        </div>

    </div>

</template>

<script>

    import Canvas from "./editor/Canvas";
    import Gallery from "./editor/Gallery";
    import VersionActions from "./editor/VersionActions";
    import ModeAndViewportToolbar from "./editor/ModeAndViewportToolbar";
    import ToolbarTop from "./editor/ToolbarTop";

    export default {

        provide: function() {
            return {
                editorComponent: this,
            };
        },

        components: {
            ModeAndViewportToolbar,
            'canvas-component': Canvas,
            Gallery,
            ToolbarTop,
            VersionActions,
        },

        props: {
            title: String,
            instruction: String,

            canvasVersions: Object,
            canvasBlocksGalleryData: Array,

            useVersioning: Boolean,
        },

        data()
        {
            return {
                activeMode: null,
                activeViewport: 'xl',
                canvasVersionsLocal: this.canvasVersions,
                localVersionState: null,
                iframeLoaded: false,
                stateSaving: false, // Manipulated else where.
                galleryDraggingBlockId: null,
                currentLanguage: Object.keys(this.canvasVersions)[0],
            };
        },

        mounted()
        {
            this.initActiveVersion();
            this.initInstance();
            this.initVersionState();
        },

        methods: {

            initActiveVersion()
            {
                // To overview due to no canvas blocks present yet?
                this.activeMode = this.canvasVersion.canvas_blocks.length > 0 ? 'content' : 'overview';
            },

            initInstance()
            {
                // @ugly Set so language switcher can reach it.
                $(this.$el).data('vueInstance', this);
            },

            initVersionState()
            {
                // @ugly TODO Vue anti pattern.
                this.$watch('$refs.canvasComponent.$refs.iframe.iframeApp', () =>
                {
                    // @ugly TODO Vue anti pattern.
                    let iframeApp = this.$refs.canvasComponent.$refs.iframe.iframeApp;

                    // Iframe app present? May be gone while iframe is loading for another language.
                    if(iframeApp)
                        iframeApp.$watch('pageComponent.state.dirty', () => {
                            this.localVersionState = 'concept';
                        });
                });
            },

            setNewLanguageCanvasVersion(canvasVersion)
            {
                // Set
                this.canvasVersionsLocal[this.currentLanguage].canvasVersion = canvasVersion;
            },

            setNewCanvasVersions(canvasVersions)
            {
                // Set
                this.canvasVersionsLocal = canvasVersions;
            },

            canvasVersionBackToLive()
            {
                // Clear overwriteable version state. Computed this.versionState() will check what is right.
                this.localVersionState = null

                // TODO High: Refresh iframe.

            },

        },

        computed: {

            canvasComponent()
            {
                return this.$refs['canvasComponent'];
            },

            versionState()
            {
                // Overwrite?
                if(this.localVersionState)
                    return this.localVersionState;

                // Check version.
                return this.canvasVersionsLocal[this.currentLanguage].activeCanvasVersion?.id && this.canvasVersion.created_at == this.canvasVersion.updated_at ? 'live' : 'concept';
            },

            canvasVersion()
            {
                return this.canvasVersionsLocal[this.currentLanguage].canvasVersion;
            },

            activeCanvasVersion()
            {
                return this.canvasVersionsLocal[this.currentLanguage].activeCanvasVersion;
            },

            isMultiLanguage()
            {
                return Object.values(this.canvasVersionsLocal).length > 1;
            },

        },

    }

</script>

<style lang="scss" scoped>

    .galaxy\:\:common-canvas-Editor {
        border: 1px solid #ddd;
        box-shadow: 0 0 50px rgba(0, 0, 0, 0.1);
        height: calc(100vh - 75px);
        z-index: 100;

        .toolbarBottom {
            border-top: 1px solid #ddd !important;
            transition: opacity .2s;

            &.loading {
                opacity: .5;
                pointer-evens: none;
            }
        }
    }

</style>